import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASE_URL } from '../constants'
import { IEmployee } from '../model/interfaces'
import { getTokenFromLocalStorage } from '../../utils'
export const employeesApi = createApi({
  reducerPath: 'employeesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_URL}/employee`,
    headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
  }),
  tagTypes: ['Employees', 'AllEmployees', 'Projects', 'ProjectEmployeeLinks'],
  endpoints: (builder) => ({
    getEmployees: builder.query<IEmployee[], void>({
      query: () => {
        return {
          method: 'GET',
          url: '',
          headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
        }
      },
      providesTags: ['AllEmployees']
    }),
    getMyEmployees: builder.query<IEmployee[], void>({
      query: () => {
        return {
          method: 'GET',
          url: '/my',
          headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
        }
      },
      providesTags: ['Employees']
    }),
    createUserEmployees: builder.mutation<void, string>({
      query: (employeeId: string) => ({
        method: 'POST',
        url: `/my/${employeeId}`,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['Employees', 'ProjectEmployeeLinks']
    }),
    deleteUserEmployee: builder.mutation<void, string>({
      query: (employeeId: string) => ({
        method: 'DELETE',
        url: `/my/${employeeId}`,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['Employees', 'ProjectEmployeeLinks']
    }),
    createEmployees: builder.mutation<void, IEmployee>({
      query: (employee: IEmployee) => ({
        method: 'POST',
        url: '',
        body: employee,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['Employees', 'AllEmployees', 'ProjectEmployeeLinks']
    }),
    updateEmployee: builder.mutation<void, IEmployee>({
      query: (employee: IEmployee) => ({
        method: 'PUT',
        url: `/${employee._id}`,
        body: employee,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['Employees', 'AllEmployees', 'Projects', 'ProjectEmployeeLinks']
    }),
    deleteEmployee: builder.mutation<void, string>({
      query: (id: string) => ({
        method: 'DELETE',
        url: `/${id}`,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['Employees', 'AllEmployees', 'Projects', 'ProjectEmployeeLinks']
    })
  })
})

export const {
  useGetMyEmployeesQuery,
  useGetEmployeesQuery,
  useCreateUserEmployeesMutation,
  useDeleteUserEmployeeMutation,
  useLazyGetEmployeesQuery,
  useCreateEmployeesMutation,
  useUpdateEmployeeMutation,
  useDeleteEmployeeMutation
} = employeesApi
